import {$, $$} from '@zimpa/dom';
import axios, {AxiosResponse} from 'axios';

const CONTAINER_SELECTOR = '.js-form';
const SUCCESS_SELECTOR = '.js-form-success';
const ERROR_SELECTOR = '.js-form-error';
const FORM_SELECTOR = '.js-form-form';
const FORM_ITEM_SELECTOR = '.js-form-form-item';
const FORM_ITEM_SELECTOR_CALL_ME_BACK = '.js-form-form-item-call-me-back';
const FORM_ITEM_SELECTOR_CALL_ME_BACK_NUMBER = '.js-form-form-item-call-me-back-number';
const FORM_ITEM_SELECTOR_CATEGORY = '.js-form-form-item-category';
const FORM_ITEM_SELECTOR_SUBJECT = '.js-form-form-item-subject';
const FORM_ITEM_SELECTOR_CATEGORY_HAS_REPORT_FIELD = 'js-form-form-item-category-has-report-field';
const FORM_ITEM_SELECTOR_CATEGORY_HAS_ORGANISATION_FIELD = 'js-form-form-item-category-has-organisation-field';
const FORM_ITEM_SELECTOR_CATEGORY_HAS_DESCRIPTION_FIELD = 'js-form-form-item-category-has-description-field';
const FORM_ITEM_SELECTOR_SUBJECT_OTHER_HAS_DESCRIPTION_FIELD = 'js-form-form-item-subject-other-has-description-field';
const FORM_ITEM_SELECTOR_CATEGORY_REPORT_ID = '.js-form-form-item-category-report_id';
const FORM_ITEM_SELECTOR_CATEGORY_ORGANISATION = '.js-form-form-item-category-organisation';
const FORM_ITEM_SELECTOR_CATEGORY_DESCRIPTION = '.js-form-form-item-category-description';
const FORM_ITEM_SELECTOR_SUBJECT_OTHER_DESCRIPTION = '.js-form-form-item-subject-other-description';

const SHOW_CLASS = 'h-show';
const HIDE_CLASS = 'h-hide';

export function instance(
    form: HTMLElement,
    success: HTMLElement,
    error: HTMLElement,
): void {

    $$(FORM_ITEM_SELECTOR_CATEGORY, form).forEach((el: HTMLInputElement): void => {

        el.addEventListener('change', (event: Event): void => {
            event.preventDefault();

            $$(FORM_ITEM_SELECTOR_CATEGORY_REPORT_ID, form).forEach((input: HTMLInputElement): void => {
                el.classList.contains(FORM_ITEM_SELECTOR_CATEGORY_HAS_REPORT_FIELD) ? input.classList.remove(HIDE_CLASS) : input.classList.add(HIDE_CLASS);
            });

            $$(FORM_ITEM_SELECTOR_CATEGORY_ORGANISATION, form).forEach((input: HTMLInputElement): void => {
                el.classList.contains(FORM_ITEM_SELECTOR_CATEGORY_HAS_ORGANISATION_FIELD) ? input.classList.remove(HIDE_CLASS) : input.classList.add(HIDE_CLASS);
            });

            $$(FORM_ITEM_SELECTOR_CATEGORY_DESCRIPTION, form).forEach((input: HTMLInputElement): void => {
                el.classList.contains(FORM_ITEM_SELECTOR_CATEGORY_HAS_DESCRIPTION_FIELD) ? input.classList.remove(HIDE_CLASS) : input.classList.add(HIDE_CLASS);
            });

        });
    });

    $$(FORM_ITEM_SELECTOR_SUBJECT, form).forEach((el: HTMLInputElement): void => {
        el.addEventListener('change', (event: Event): void => {
            event.preventDefault();
            $$(FORM_ITEM_SELECTOR_SUBJECT_OTHER_DESCRIPTION, form).forEach((input: HTMLInputElement): void => {
                el.classList.contains(FORM_ITEM_SELECTOR_SUBJECT_OTHER_HAS_DESCRIPTION_FIELD) ? input.classList.remove(HIDE_CLASS) : input.classList.add(HIDE_CLASS);
            });
        });


    });

    $$(FORM_ITEM_SELECTOR_CALL_ME_BACK, form).forEach((el: HTMLInputElement): void => {

        el.addEventListener('change', (event: Event): void => {
            event.preventDefault();

            $$(FORM_ITEM_SELECTOR_CALL_ME_BACK_NUMBER, form).forEach((chk: HTMLInputElement): void => {

                el.value === "false" ? chk.classList.add(HIDE_CLASS) : chk.classList.remove(HIDE_CLASS);
            });

            $$(FORM_ITEM_SELECTOR_CALL_ME_BACK_NUMBER + " " + FORM_ITEM_SELECTOR, form).forEach((input: HTMLInputElement): void => {

                el.value === "false" ? input.removeAttribute("required") : input.setAttribute("required", "true");
            });

        });
    });

    form.addEventListener('submit', (event: Event): void => {
        event.preventDefault();

        const data = {};

        $$(FORM_ITEM_SELECTOR, form).forEach((el: HTMLInputElement): void => {
            if (el.type === "radio") {
                if (el.checked) {
                    data[el.name] = el.value;
                }
            } else if (data[el.name]) {
                if (!Array.isArray(data[el.name])) {
                    data[el.name] = [data[el.name]];
                }

                data[el.name].push(el.value);
            } else {
                data[el.name] = el.value;
            }
        });

        axios
            .post(<string>form.getAttribute('action'), data)
            .then((response: AxiosResponse<any>): void => {
                form.classList.add(HIDE_CLASS);

                if (response.data === null) {
                    error.classList.add(SHOW_CLASS);
                } else {
                    success.classList.add(SHOW_CLASS);
                }
            });
    });

}

export function form(): void {
    $$(CONTAINER_SELECTOR).forEach((container: HTMLElement): void => {
        const form = $<HTMLElement>(FORM_SELECTOR, container);
        const success = $<HTMLElement>(SUCCESS_SELECTOR, container);
        const error = $<HTMLElement>(ERROR_SELECTOR, container);

        if (
            form === undefined ||
            success === undefined ||
            error === undefined
        ) {
            return;
        }

        instance(form, success, error);
    });
}
